import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';

import { initMatomoTagManagerScript } from '@fora-monorepo/webapp-analytics';
import { GlobalStyles, StyleSheetManagerWithForwardProp } from '@foradevelopment/fora-ui';
import { CookieBanner } from '@foradevelopment/fora-react-ui';

import { setRefreshInterceptor } from './auth/services';
import PrintStyles from './PrintStyles';
import { store } from './redux/store';
import { appRouter } from './router/appRouter';
import { initAppInsights, reactPlugin } from './analytics/appInsights';
import { setUnderMaintenanceInterceptor } from './redux/error/middlewares/setUnderMaintenanceInterceptor';
import { envConfig } from './config';
import './i18n/i18n';

const { dispatch } = store;

initAppInsights();
initMatomoTagManagerScript(envConfig.matomoTagManagerUrl);
setRefreshInterceptor(dispatch);
setUnderMaintenanceInterceptor(dispatch);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <AppInsightsContext.Provider value={reactPlugin}>
      <StyleSheetManagerWithForwardProp>
        <GlobalStyles />
        <PrintStyles />
        <CookieBanner showBannerDelayMs={5000} domain={envConfig.cookieDomain} contentWidth={['100%', 1200, 1170]} />
        <Provider store={store}>
          <RouterProvider router={appRouter} />
        </Provider>
      </StyleSheetManagerWithForwardProp>
    </AppInsightsContext.Provider>
  </StrictMode>
);
